class CartUpdater {
  constructor() {
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", () => this.init())
      : this.init();
    this.observers = [];
  }

  addObserver(cb) {
    this.observers.push(cb);
  }

  notifyObservers(d) {
    this.observers.forEach(cb => cb(d));
  }

  init() {
    try {
      this.bindEvents();
    } catch (e) {}
  }

  bindEvents() {
    document.body.addEventListener(
      "change",
      e => {
        if (e.target.matches('input[name="updates[]"]')) this.handleQty(e.target);
      },
      { passive: true }
    );
    document.body.addEventListener(
      "click",
      e => {
        const b = e.target.closest(".quantity__button");
        if (b) {
          e.preventDefault();
          this.handleBtn(b);
        }
      },
      { passive: false }
    );
  }

  handleQty(i) {
    try {
      const q = parseInt(i.value) || 0;
      const k = i.getAttribute("data-key") || i.getAttribute("id");
      if (k && q >= 0) this.update(k, q);
    } catch (e) {
      location.reload();
    }
  }

  handleBtn(b) {
    try {
      const w = b.closest(".quantity");
      if (!w) return;
      const i = w.querySelector('input[name="updates[]"]');
      if (!i) return;
      const q = parseInt(i.value) || 0;
      const n = b.classList.contains("quantity__button--plus")
        ? q + 1
        : Math.max(0, q - 1);
      i.value = n;
      const k = i.getAttribute("data-key") || i.getAttribute("id");
      if (k) this.update(k, n);
    } catch (e) {
      location.reload();
    }
  }

  async update(k, q) {
    try {
      document.body.classList.add("cart-updating");
      const d = await (
        await Promise.race([
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify({ id: k, quantity: q })
          }),
          new Promise((_, r) => setTimeout(() => r(new Error("Timeout")), 1e4))
        ])
      ).json();
      this.notifyObservers(d);
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: d }));
    } catch (e) {}
    finally {
      document.body.classList.remove("cart-updating");
    }
  }
}

class PromoUpdater {
  constructor() {
    this.promoTiers = [
      { required: 2, free: 1, total: 3 },
      { required: 3, free: 2, total: 5 },
      { required: 4, free: 3, total: 7 },
      { required: 5, free: 5, total: 10 }
    ];
    this.addStyles();
    this.init();
  }

  addStyles() {
    const s = document.createElement("style");
    s.textContent = `
.promo-message-container {
  margin: 0 0 24px; /* 底部留白，与下方商品列表分开 */
  padding: 20px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid rgba(8, 121, 90,.2);
  box-shadow: 0 1px 8px rgba(0,0,0,.03);
  box-sizing: border-box;
  max-width: 100%;
}
.promo-message { text-align: center; }
.promo-title { font-size: 1.2em; font-weight: 600; color: #08795a; margin-bottom: 12px; }
.promo-content { color: #1f2937; line-height: 1.5; }
.offer-tiers {
  margin-top: 15px;
  padding: 15px;
  background: #f9fafb;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
.tier-item { padding: 6px 14px; background: #fff; border: 1px solid #e5e7eb; border-radius: 4px; font-size: 14px; }
.tier-item.best { border-color: #08795a; background: #ecfdf5; font-weight: 600; }
.new-products-link { display: inline-block; margin-top: 12px; color: #08795a; font-weight: 500; text-decoration: none; }
.new-products-link:hover span { margin-left: 4px; }
.progress-container { width: 100%; height: 10px; background: #e5e7eb; border-radius: 5px; margin: 12px 0; overflow: hidden; }
.progress-bar { height: 100%; background: linear-gradient(90deg, #08795a, #34d399); border-radius: 5px; transition: width .5s; }
.next-tier { margin-top: 8px; font-weight: 500; color: #08795a; }
.cart-updating { opacity: .8; pointer-events: none; transition: opacity .3s; }
.cart-updating:after {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,.6);
  z-index: 999999;
}
.quantity__button {
  border: none;
  background: #f9fafb;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  transition: all .2s;
  color: #08795a;
}
.quantity__button:hover { background: #ecfdf5; }
.quantity__button--plus { border: 1px solid #08795a; }
.quantity__button--minus { border: 1px solid #d1d5db; }
input[name="updates[]"] {
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 6px;
  text-align: center;
  max-width: 50px;
}
input[name="updates[]"]:focus { border-color: #08795a; outline: none; }
.quantity { display: flex; align-items: center; gap: 6px; }
`;
    document.head.appendChild(s);
  }

  init() {
    this.createMessageElement();
    setInterval(() => this.ensureAndUpdate(), 3e3);
  }

  ensureAndUpdate() {
    const el = document.getElementById("promo-message");
    if (!el) {
      this.createMessageElement();
    } else {
      this.updatePromoMessage();
    }
  }

  createMessageElement() {
    const f = document.querySelector('form[action="/cart"]');
    if (!f) return;
    if (document.getElementById("promo-message")) return;
    const d = document.createElement("div");
    d.id = "promo-message";
    d.className = "promo-message-container";
    f.insertAdjacentElement("beforebegin", d);
    this.updatePromoMessage();
  }

  updatePromoMessage() {
    const el = document.getElementById("promo-message");
    if (!el) return;
    fetch("/cart.js")
      .then(r => r.json())
      .then(c => {
        const count = c.item_count;
        let html = "";
        if (count === 0) {
          html = `
<div class="promo-message">
  <div class="promo-title">🎁 SPECIAL OFFER</div>
  <div class="promo-content">
    <div class="current-offer">Start saving with BUY 2 GET 1 FREE!</div>
    <div class="offer-tiers">${this.promoTiers.map((t, i) =>
      `<div class="tier-item ${i === this.promoTiers.length - 1 ? "best" : ""}">Buy ${t.required} Get ${t.free} Free</div>`
    ).join("")}</div>
    <a href="/collections/new" class="new-products-link">Check out our new arrivals! <span>→</span></a>
  </div>
</div>`;
        } else {
          const cur = [...this.promoTiers].reverse().find(t => count >= t.total);
          const next = this.promoTiers.find(t => t.total > count);
          if (!next) {
            html = `
<div class="promo-message">
  <div class="promo-title">🌟 MAXIMUM SAVINGS UNLOCKED</div>
  <div class="promo-content">
    <div class="max-savings">You've reached our BEST offer!<br>Buy ${cur.required} Get ${cur.free} Free (${count} items in cart)</div>
    <a href="/collections/new" class="new-products-link">See what's new in our collection! <span>→</span></a>
  </div>
</div>`;
          } else {
            const needed = next.total - count;
            const pct = (count / next.total) * 100;
            html = `
<div class="promo-message">
  <div class="promo-title">🎉 UNLOCK MORE SAVINGS</div>
  <div class="promo-content">
    <div class="current-offer">Current: Buy ${cur?.required || 2} Get ${cur?.free || 1} Free (${count} items in cart)</div>
    <div class="progress-container"><div class="progress-bar" style="width:${pct}%"></div></div>
    <div class="next-tier">Add ${needed} more for Buy ${next.required} Get ${next.free} Free!</div>
    <a href="/collections/new" class="new-products-link">Discover new arrivals! <span>→</span></a>
  </div>
</div>`;
          }
        }
        el.innerHTML = html;
      })
      .catch(() => {});
  }
}

function init() {
  const cu = new CartUpdater();
  const pu = new PromoUpdater();
  cu.addObserver(() => pu.ensureAndUpdate());
  window.cartUpdater = cu;
  window.promoUpdater = pu;
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
else init();